"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionsValidationError = exports.getFallbackPlayerName = exports.isWithPlayerIdOptions = exports.providePlayerIds = void 0;
__exportStar(require("./EnumOption"), exports);
var providePlayerIds_1 = require("./providePlayerIds");
Object.defineProperty(exports, "providePlayerIds", { enumerable: true, get: function () { return __importDefault(providePlayerIds_1).default; } });
var isWithPlayerIdOptions_1 = require("./isWithPlayerIdOptions");
Object.defineProperty(exports, "isWithPlayerIdOptions", { enumerable: true, get: function () { return __importDefault(isWithPlayerIdOptions_1).default; } });
var getFallbackPlayerName_1 = require("./getFallbackPlayerName");
Object.defineProperty(exports, "getFallbackPlayerName", { enumerable: true, get: function () { return __importDefault(getFallbackPlayerName_1).default; } });
var OptionsValidationError_1 = require("./OptionsValidationError");
Object.defineProperty(exports, "OptionsValidationError", { enumerable: true, get: function () { return __importDefault(OptionsValidationError_1).default; } });
